export const PATIENT_TEST_TYPE_KEY = 'patientOnboardingTestType';
export const PATIENT_INPUT_TYPE_KEY = 'patientOnboardingInputType';

const VALID_TEST_TYPES = new Set(['adult', 'child', 'infant']);
const VALID_INPUT_TYPES = new Set(['doctorTest', 'selfTest', 'oneDeviceTest']);

// Returns a persisted patient test type or adult when missing or invalid.
export function readPatientTestType(): string {
  const stored = sessionStorage.getItem(PATIENT_TEST_TYPE_KEY);
  if (stored && VALID_TEST_TYPES.has(stored)) {
    return stored;
  }
  return 'adult';
}

// Persists the selected patient test type for onboarding navigation.
export function writePatientTestType(testType: string): void {
  if (!VALID_TEST_TYPES.has(testType)) {
    return;
  }
  sessionStorage.setItem(PATIENT_TEST_TYPE_KEY, testType);
}

// Returns whether a patient test type was stored in session.
export function hasStoredPatientTestType(): boolean {
  const stored = sessionStorage.getItem(PATIENT_TEST_TYPE_KEY);
  return Boolean(stored && VALID_TEST_TYPES.has(stored));
}

// Resolves test type from route state with session fallback.
export function resolvePatientTestType(routeTestType?: string): string {
  if (routeTestType && VALID_TEST_TYPES.has(routeTestType)) {
    return routeTestType;
  }
  return readPatientTestType();
}

// Resolves test type for doctor session; room patient type wins, no adult default.
export function resolveDoctorSessionTestType(routeTestType?: string, patientRoomTestType?: string): string | undefined {
  if (patientRoomTestType && VALID_TEST_TYPES.has(patientRoomTestType)) {
    return patientRoomTestType;
  }
  if (routeTestType && VALID_TEST_TYPES.has(routeTestType)) {
    return routeTestType;
  }
  return undefined;
}

// Returns a persisted input type or doctorTest when missing or invalid.
export function readPatientInputType(): string {
  const stored = sessionStorage.getItem(PATIENT_INPUT_TYPE_KEY);
  if (stored && VALID_INPUT_TYPES.has(stored)) {
    return stored;
  }
  return 'doctorTest';
}

// Persists the selected patient input type for onboarding navigation.
export function writePatientInputType(inputType: string): void {
  if (!VALID_INPUT_TYPES.has(inputType)) {
    return;
  }
  sessionStorage.setItem(PATIENT_INPUT_TYPE_KEY, inputType);
}

// Resolves input type from route state with session fallback.
export function resolvePatientInputType(routeInputType?: string): string {
  if (routeInputType && VALID_INPUT_TYPES.has(routeInputType)) {
    return routeInputType;
  }
  return readPatientInputType();
}

// Removes persisted patient onboarding selections from sessionStorage.
export function clearPatientOnboardingSession(): void {
  sessionStorage.removeItem(PATIENT_TEST_TYPE_KEY);
  sessionStorage.removeItem(PATIENT_INPUT_TYPE_KEY);
}
